export default __webpack_public_path__ + "static/media/CSIO_BoardGrouping_1.dda6486a.png";